/**
 * Create Delivery Addresses context for custom hook
 */


import { createContext } from 'react'

const DeliveryAddressesContext = createContext({
  createDeliveryAddresses: () => {},
  deleteDeliveryAddresses: () => {},
  fetchDeliveryAddresses: () => {},
  updateDeliveryAddresses: () => {}
})

export default DeliveryAddressesContext
